import { render } from "./DoubleArrowIcon.vue?vue&type=template&id=af093886"
import script from "./DoubleArrowIcon.vue?vue&type=script&lang=js"
export * from "./DoubleArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__